<template>
  <div>
    <PageHeader title="Versions" />

    <PageContent>
      <div
        v-for="app in applications"
        :key="app.slug"
        class="w-full border rounded-md p-4 mb-4"
      >
        <div class="grid grid-cols-1 lg:grid-cols-12 gap-3 items-end">
          <div class="lg:col-span-2">
            <p class="font-semibold">{{ app.label }}</p>
            <p class="text-xs text-gray-600">iOS: {{ displayVersion(app.currentVersionIos) }}</p>
            <p class="text-xs text-gray-600">Android: {{ displayVersion(app.currentVersionAndroid) }}</p>
          </div>

          <div class="lg:col-span-5">
            <label class="block text-xs mb-1">Version iOS</label>
            <div class="flex space-x-2">
              <input
                v-model="app.versionIos"
                class="w-full border-black border p-1"
              />
              <button
                :disabled="!!app.savingField"
                @click="setFieldVersion(app, 'ios')"
                class="rounded bg-blue-400 text-white p-2 disabled:opacity-50"
              >
                {{ app.savingField === 'ios' ? '...' : 'OK' }}
              </button>
            </div>
          </div>

          <div class="lg:col-span-5">
            <label class="block text-xs mb-1">Version Android</label>
            <div class="flex space-x-2">
              <input
                v-model="app.versionAndroid"
                class="w-full border-black border p-1"
              />
              <button
                :disabled="!!app.savingField"
                @click="setFieldVersion(app, 'android')"
                class="rounded bg-blue-400 text-white p-2 disabled:opacity-50"
              >
                {{ app.savingField === 'android' ? '...' : 'OK' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </PageContent>
  </div>
</template>

<script>
import { http } from '@/services/api.service'
import PageHeader from '@/components/PageHeader'
import PageContent from '@/components/PageContent.vue'

export default {
  name: 'app-versions',
  components: {
    PageHeader,
    PageContent
  },
  data () {
    return {
      applications: [
        {
          label: 'Maviepro',
          slug: 'maviepro',
          versionIos: '',
          versionAndroid: '',
          currentVersionIos: '',
          currentVersionAndroid: '',
          savingField: null
        },
        {
          label: 'Tract',
          slug: 'tract',
          versionIos: '',
          versionAndroid: '',
          currentVersionIos: '',
          currentVersionAndroid: '',
          savingField: null
        }
      ]
    }
  },
  methods: {
    displayVersion (version) {
      return version || '-'
    },
    firstDefinedString (...values) {
      const value = values.find(v => typeof v === 'string' && v.length > 0)
      return value || ''
    },
    applyVersionResponse (app, responseData) {
      if (!app || !responseData) {
        return
      }

      const versions = responseData.versions || {}

      app.currentVersionIos = this.firstDefinedString(
        responseData.version_ios,
        responseData.ios,
        versions.ios,
        responseData.version
      )
      app.currentVersionAndroid = this.firstDefinedString(
        responseData.version_android,
        responseData.android,
        versions.android,
        responseData.version
      )

      app.versionIos = app.currentVersionIos
      app.versionAndroid = app.currentVersionAndroid
    },
    async getVersion (slug) {
      try {
        const response = await http.get(`/application/${slug}/version`)
        const app = this.applications.find(a => a.slug === slug)
        this.applyVersionResponse(app, response.data)
      } catch (e) {
        console.log('Error fetching version:', e)
      }
    },
    async setFieldVersion (app, field) {
      const payload = {}
      let nextValue = ''
      let currentValue = ''

      if (field === 'ios') {
        nextValue = app.versionIos ? app.versionIos.trim() : ''
        currentValue = app.currentVersionIos
        if (nextValue && nextValue !== currentValue) {
          payload.ios = nextValue
        }
      }

      if (field === 'android') {
        nextValue = app.versionAndroid ? app.versionAndroid.trim() : ''
        currentValue = app.currentVersionAndroid
        if (nextValue && nextValue !== currentValue) {
          payload.android = nextValue
        }
      }

      if (Object.keys(payload).length === 0 || app.savingField) {
        return
      }

      app.savingField = field
      try {
        const response = await http.post(`/application/${app.slug}/version`, payload)
        this.applyVersionResponse(app, response.data)
      } catch (e) {
        console.log('Error setting version:', e)
      } finally {
        app.savingField = null
      }
    }
  },
  mounted () {
    this.applications.forEach(app => {
      this.getVersion(app.slug)
    })
  }
}
</script>
